import React from "react";
import {Breadcrumbs} from "@mui/material";
import BaseLayout from "@/Layouts/BaseLayout";
import FaqItem from "@/Pages/Fag/FaqItem";
import Link from "@/Layouts/Link";
import AskQuestion from "@/Components/Site/AskQuestion";
import "@/Pages/Fag/scss/index.scss";

const Index = (props) => {
    const {mobileApp = false, h1 = ''} = props;

    return (
        <BaseLayout {...props}>
            <section className={`section`}>
                <div className={`container`}>
                    {!mobileApp && (
                        <Breadcrumbs maxItems={2} itemsAfterCollapse={2} className={`breadcrumbs`}>
                            <Link className={`breadcrumbs__link`} href={`/`}>Главная</Link>
                            <p className={`breadcrumbs__text`}>{h1}</p>
                        </Breadcrumbs>
                    )}
                    <h1 className={`h1`}>{h1}</h1>
                    <div className={`faq`}>
                        <div className={`faq__elements`}>
                            <FaqItem {...props} />
                        </div>
                        {!mobileApp && (
                            <div className={`faq__forms`}>
                                <AskQuestion {...props} />
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </BaseLayout>
    );
};

export default Index;
